"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./footer.scss");
var core_1 = require("@material-ui/core");
var BaseFooter = function (_a) {
    var images = _a.images, labels = _a.labels, contacts = _a.contacts, address = _a.address, buildBy = _a.buildBy, footerLinks = _a.footerLinks, socialLinks = _a.socialLinks;
    var appLogo = images.appLogo;
    var appTitle = labels.appTitle, contactUs = labels.contactUs, appCredit = labels.appCredit;
    var email = contacts.email;
    var location = address.location, code = address.code, mapIcon = address.mapIcon, emailIcon = address.emailIcon;
    var buildByLabel = buildBy.title, buildByItems = buildBy.items;
    return (react_1.default.createElement("footer", { className: "bottomContainer" },
        react_1.default.createElement("div", { className: "linksContainer" },
            react_1.default.createElement("div", { className: "navLinks" },
                react_1.default.createElement("div", { className: "header" },
                    react_1.default.createElement("img", { src: appLogo, alt: "App logo" }),
                    react_1.default.createElement("span", { className: "text" }, appTitle || ''))),
            react_1.default.createElement("span", { className: "verticalLine" }),
            react_1.default.createElement("div", { className: "bottomContact" },
                react_1.default.createElement("span", null, contactUs || ''),
                react_1.default.createElement("div", { className: "contactInfo" },
                    react_1.default.createElement("div", { className: "contactItem" },
                        react_1.default.createElement("div", { className: "icon" }, emailIcon),
                        react_1.default.createElement("a", { href: "mailto:" + email }, email)),
                    react_1.default.createElement("div", { className: "contactItem" },
                        react_1.default.createElement("div", { className: "icon" }, mapIcon),
                        react_1.default.createElement("div", { className: "address" },
                            react_1.default.createElement("span", null, location || ''),
                            react_1.default.createElement("span", null, code || ''))))),
            react_1.default.createElement("span", { className: "verticalLine" }),
            react_1.default.createElement("div", { className: "builtBy" },
                react_1.default.createElement("div", { className: "builtByContainer" },
                    react_1.default.createElement("span", null, buildByLabel || ''),
                    react_1.default.createElement("div", { className: "builtByItems" }, buildByItems.map(function (item) {
                        return (react_1.default.createElement(core_1.Link, { key: "buildBy-item-" + item.name, href: item.link, target: "_blank" },
                            react_1.default.createElement("img", { width: 100, src: item.logo, alt: "logo" })));
                    })))),
            react_1.default.createElement("div", { className: "mobileFooterLinks" },
                react_1.default.createElement("div", { className: "links" }, footerLinks.map(function (ft) {
                    return (react_1.default.createElement(core_1.Link, { className: "navLink", key: "footer-link-" + ft.name, href: ft.link || '', target: "_blank" }, ft.label || ''));
                })))),
        react_1.default.createElement("div", { className: "footerContainer" },
            react_1.default.createElement("div", { className: "footer" },
                react_1.default.createElement("div", { className: "links" }, footerLinks.map(function (ft) {
                    return (react_1.default.createElement(core_1.Link, { className: "navLink", key: "footer-link-" + ft.name, href: ft.link || '', target: "_blank" }, ft.label || ''));
                })),
                react_1.default.createElement("span", { className: "copyright" },
                    "\u00A9 ",
                    new Date().getFullYear(),
                    " ",
                    appCredit || ''),
                react_1.default.createElement("div", { className: "socialLinks" }, socialLinks.map(function (sl) {
                    return (react_1.default.createElement(core_1.Link, { key: "social-link-" + sl.name, href: sl.link || '', target: "_blank" }, sl.icon));
                }))))));
};
exports.default = BaseFooter;
